import CompanyLayout from '@/components/feature/CompanyLayout';
import { useTheme } from '@/contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

const productNavItems = [
  { path: '/markets', label: 'Markets' },
  { path: '/ai-agents', label: 'AI Agents' },
  { path: '/vaults', label: 'Vaults' },
  { path: '/leaderboard', label: 'Leaderboard' },
  { path: '/fees', label: 'Fees' },
];

const vaults = [
  { name: 'Delta Neutral BTC', strategy: 'Market-neutral yield through basis trading', apy: 18.5, tvl: 12400000, risk: 'Low', users: 1240 },
  { name: 'ETH Staking Plus', strategy: 'ETH staking rewards + MEV extraction', apy: 6.8, tvl: 45600000, risk: 'Low', users: 3450 },
  { name: 'Funding Rate Arbitrage', strategy: 'Cross-exchange funding rate capture', apy: 32.4, tvl: 8900000, risk: 'Medium', users: 890 },
  { name: 'Gamma Scalping Vault', strategy: 'Options gamma hedging with perpetuals', apy: 45.2, tvl: 5600000, risk: 'High', users: 567 },
  { name: 'AI Momentum Vault', strategy: 'ML-driven momentum trading across 20+ pairs', apy: 78.9, tvl: 3200000, risk: 'High', users: 234 },
  { name: 'Stablecoin Yield', strategy: 'Lending + liquidity provision across chains', apy: 12.3, tvl: 67800000, risk: 'Low', users: 8900 },
];

export default function VaultsPage() {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  const bgCard = isDark ? 'bg-[#0a0a0a]' : 'bg-white';
  const borderLight = isDark ? 'border-white/[0.06]' : 'border-black/[0.06]';
  const textPrimary = isDark ? 'text-white' : 'text-[#111]';
  const textSecondary = isDark ? 'text-[#888]' : 'text-[#666]';
  const textMuted = isDark ? 'text-[#555]' : 'text-[#999]';

  return (
    <CompanyLayout
      title={t('vaults.title', 'Vaults')}
      subtitle={t('vaults.subtitle', 'Automated yield-generating strategies with built-in risk management')}
      category="Product"
      navItems={productNavItems}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {vaults.map((vault) => (
          <div key={vault.name} className={`p-5 rounded-xl border ${borderLight} ${bgCard} flex flex-col`}>
            <div className="flex items-center justify-between mb-3">
              <h3 className={`font-semibold ${textPrimary}`}>{vault.name}</h3>
              <span className={`text-xs px-2 py-1 rounded-full border ${borderLight} ${vault.risk === 'Low' ? 'text-[#00ff88]' : vault.risk === 'Medium' ? 'text-[#ffaa00]' : 'text-[#ff5566]'}`}>
                {t(`vaults.${vault.risk.toLowerCase()}`, vault.risk)} {t('vaults.riskLevel', 'Risk')}
              </span>
            </div>
            <p className={`text-sm mb-4 ${textSecondary}`}>{vault.strategy}</p>
            <div className="mt-auto">
              <div className="flex items-baseline gap-2 mb-3">
                <span className="text-2xl font-bold text-[#00ff88]">{vault.apy}%</span>
                <span className={`text-xs ${textMuted}`}>{t('vaults.apy', 'APY')}</span>
              </div>
              <div className={`flex items-center justify-between text-xs ${textMuted}`}>
                <span>{t('vaults.tvl', 'TVL')}: ${(vault.tvl / 1e6).toFixed(1)}M</span>
                <span>{vault.users.toLocaleString()} {t('vaults.depositors', 'depositors')}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </CompanyLayout>
  );
}